import React, { useEffect, useState } from "react";
import Button from "../../../components/CustomButtons/Button";
import TranslationWrapper, { getTranslation } from "../../../components/TranslationWrapper/TranslationWrapper.tsx";

import CardBody from "../../../components/Card/CardBody";
import { Card, Collapse, FormLabel, Grid, Typography } from "@mui/material";
import TimeTable from "../../../components/TimeTable/TimeTable";
import { convertArrayToSelectOptions } from "../../../templateHelpers";
import { waitTimeMode } from "../../../variables/app";
import TimeoddsModal from "../Modals/TimeoddsModal";
import { useController, useFormContext, useWatch } from "react-hook-form";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";
import FormControlledInputTC from "../../../components/Forms/FormControlledInputTC";
import FormSelectTC from "../../../components/Forms/FormSelectTC";
import FormTimePicker from "../../../components/Forms/FormTimePicker";
import FormTextTC from "../../../components/Forms/FormTextTC";
import TimeSettings from "./TimeSettings/TimeSettings";
import FormFieldTwoColumns from "../../../components/Forms/Layouts/FormFieldTwoColumns";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AccordionDetails from "@mui/material/AccordionDetails";
import Editor from "../../SunEditor";
import { Alert } from "@mui/lab";
import axios from "axios";

function Preordering() {
  const waitTimeModeOptions = convertArrayToSelectOptions(waitTimeMode);

  const [deliveryTimeSchemeModal, setDeliveryTimeSchemeModal] = useState(false);

  /**
   * Set the type of TimeOdds
   * 1 = OPEN scheme
   * 2 = DELIVERY scheme
   */
  const [deliveryTimeSchemeType, setDeliveryTimeSchemeType] = useState(1);
  const [timeOdds, setTimeOdds] = useState([]);

  const { control, vestigingId } = useFormContext();
  const {
    field: { value: timeTableValue, onChange: timeTableOnChange },
  } = useController({ control, name: "time_settings__timeOpenScheme" });

  const {
    field: { value: deliveryTimeSchemeValue, onChange: deliveryTimeSchemeOnChange },
  } = useController({ control, name: "time_settings__deliveryTimeScheme" });

  const preOrderingActive = useWatch({ name: "preOrderingActive" });
  const preOrdering = useWatch({ name: "preOrdering" });
  const createTimetable = useWatch({ name: "createTimetable" });

  return (
    <Grid container spacing={1}>
      <Grid alignContent={"flex-start"} item lg={6} xs={12}>
        <Grid container spacing={1}>
          <Grid alignContent={"flex-start"} item xs={12}>
            <Card>
              <CardBody alignItems={"flex-start"} style={{ padding: 16 }}>
                <Grid item xs={12}>
                  <h3>
                    <TranslationWrapper
                      tDefault={"Openingstijden"}
                      tKey={"vestigingen.form.tijden.headers.openingstijden"}
                    />
                  </h3>
                  <h4>
                    <TranslationWrapper
                      tDefault={"The times when the application is usable for guests"}
                      tKey={"vestigingen.form.tijden.headers.timesThatTheGuestCanUseTheApplication"}
                    />
                  </h4>
                </Grid>
                <Collapse in={!timeTableValue} unmountOnExit>
                  <Alert severity={"warning"}>
                    <p>
                      <TranslationWrapper
                        tDefault={"No timetable defined. you are open 24/7"}
                        tKey={"timeTable.configuration-warning"}
                      />
                    </p>
                    <p>
                      <TranslationWrapper
                        tDefault={"Create a timeTable to change opening hours and to add exceptions"}
                        tKey={"timeTable.configuration-warning.solution"}
                      />
                    </p>
                  </Alert>
                </Collapse>
                {timeTableValue !== undefined ? (
                  <Accordion defaultExpanded={timeTableValue} key={"timeTableValue"} sx={{ width: "100%" }}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <TranslationWrapper
                        tDefault={"Timetable"}
                        tKey={"vestigingen.form.delivery_settings.label.timeTableValue"}
                      />
                    </AccordionSummary>
                    <AccordionDetails>
                      <TimeTable
                        data={timeTableValue}
                        inputName={"time_settings__timeOpenScheme"}
                        onChange={(value) => {
                          if (value != null && Object.keys(value).length === 0) {
                            timeTableOnChange(null);
                          } else {
                            timeTableOnChange(JSON.stringify(value));
                          }
                        }}
                      />
                      <Collapse in={timeTableValue} unmountOnExit>
                        <Grid item xs={12}>
                          <Button
                            color={"warning"}
                            onClick={() => {
                              setDeliveryTimeSchemeType(1);
                              setDeliveryTimeSchemeModal(true);
                            }}
                          >
                            <TranslationWrapper tKey={"Exceptions of schema"} />
                          </Button>
                        </Grid>
                      </Collapse>
                    </AccordionDetails>
                  </Accordion>
                ) : null}
              </CardBody>
            </Card>
          </Grid>
          <Grid alignContent={"flex-start"} item xs={12}>
            <Card>
              <CardBody>
                <Grid item xs={12}>
                  <h3>
                    <TranslationWrapper
                      tDefault={"Pre ordering Events"}
                      tKey={"vestigingen.form.tijden.headers.preordering_events"}
                    />
                  </h3>
                </Grid>
                <FormSwitchTC
                  name={"preOrdering"}
                  tDefault={"Pre ordering op voorstellingen"}
                  tKey={"vestigingen.form.preordering.label.preOrdering"}
                />
                {preOrdering ? (
                  <FormControlledInputTC
                    name={"preOrderHideAfter"}
                    rules={{
                      min: { value: 0, message: getTranslation("The minimum value is 0!") },
                    }}
                    suffix={" " + getTranslation("global.minuten", "Minuten")}
                    tDefault={"Hide slot x minutes before"}
                    tKey={"vestigingen.form.preordering.label.preOrderHideAfter"}
                    type={"number"}
                  />
                ) : null}
              </CardBody>
            </Card>
          </Grid>
        </Grid>
      </Grid>
      <Grid alignContent={"flex-start"} item lg={6} xs={12}>
        <Grid container spacing={1}>
          <Grid alignContent={"flex-start"} item xs={12}>
            <Card>
              <CardBody>
                <Grid item xs={12}>
                  <h3>
                    <TranslationWrapper tDefault={"Verlooptijd"} tKey={"vestigingen.form.tijden.headers.verlooptijd"} />
                  </h3>
                </Grid>
                <FormTextTC
                  name={"logoutUrl"}
                  tDefault={"Na verlooptijd naar url"}
                  tKey={"vestigingen.form.overige.label.logoutUrl"}
                />
                <FormTextTC
                  name={"logoutRedirect"}
                  tDefault={"Logout redirect"}
                  tKey={"vestigingen.form.overige.label.logoutRedirect"}
                />
              </CardBody>
            </Card>
          </Grid>
          <Grid alignContent={"flex-start"} item xs={12}>
            <Card>
              <CardBody alignItems={"flex-start"} style={{ padding: 16, display: "flex", flexWrap: "wrap" }}>
                <Grid item xs={12}>
                  <h3>
                    <TranslationWrapper
                      tDefault={"Pre ordering (datum/tijd)"}
                      tKey={"vestigingen" + "." + "form.tijden.headers.preordering"}
                    />
                  </h3>
                </Grid>
                <FormSwitchTC
                  name={"preOrderingActive"}
                  tDefault={"Pre ordering actief op datum & tijd"}
                  tKey={"vestigingen.form.preordering.label.preOrderingActive"}
                />
                {preOrderingActive ? (
                  <>
                    <TimeSettings
                      data={deliveryTimeSchemeValue ?? "{}"}
                      inputName={"time_settings__deliveryTimeScheme"}
                      onChange={(value) => {
                        deliveryTimeSchemeOnChange(JSON.stringify(value));
                      }}
                      // showMaxItems
                    />
                    <Grid item xs={12}>
                      <Button
                        color={"warning"}
                        onClick={() => {
                          setDeliveryTimeSchemeType(2);
                          setDeliveryTimeSchemeModal(true);
                        }}
                      >
                        <TranslationWrapper tKey={"Exceptions of schema"} />
                      </Button>
                    </Grid>
                    <FormControlledInputTC
                      name={"preOrderTimeOffset"}
                      rules={{
                        min: { value: 0, message: getTranslation("The minimum value is 0!") },
                      }}
                      suffix={" " + getTranslation("global.minuten", "Minuten")}
                      tDefault={"Time block size"}
                      tKey={"vestigingen.form.preordering.label.preOrderTimeOffset"}
                      type={"number"}
                    />

                    <FormSelectTC
                      name={"waitTimeMode"}
                      options={waitTimeModeOptions}
                      tDefault={"Wachtijd modus"}
                      tKey={"vestigingen.form.overige.label.waitTimeMode"}
                    />

                    <FormControlledInputTC
                      name={"waitTime"}
                      rules={{
                        min: { value: 0, message: getTranslation("The minimum value is 0!") },
                      }}
                      suffix={" " + getTranslation("global.minuten", "Minuten")}
                      tKey={"Wachtijd bestelling"}
                      type={"number"}
                    />
                    <FormTimePicker
                      name={"preOrderSameDayDeliveryBefore"}
                      tDefault={"Besteld voor X uur (SDD)"}
                      tKey={"vestigingen.form.preordering.label.preOrderSameDayDeliveryBefore"}
                    />
                    <FormControlledInputTC
                      name={"delivery_settings__deliverydayOffset"}
                      rules={{
                        min: { value: 0, message: getTranslation("The minimum value is 0!") },
                      }}
                      suffix={" " + getTranslation("global.dagen", "dag(en)")}
                      tDefault={"Eerst volgende dag bezorging"}
                      tKey={"vestigingen.form.preordering.label.deliverydayOffset"}
                      type={"number"}
                    />
                    <FormControlledInputTC
                      name={"preOrderMaxDays"}
                      rules={{
                        min: { value: 0, message: getTranslation("The minimum value is 0!") },
                      }}
                      suffix={" " + getTranslation("global.dagen", "dag(en)")}
                      tDefault={"Max dagen vooruit"}
                      tKey={"vestigingen.form.preordering.label.preOrderMaxDays"}
                      type={"number"}
                    />
                    <FormControlledInputTC
                      name={"preOrderPrintOffsetMin"}
                      suffix={" " + getTranslation("global.minuten", "Minuten")}
                      tDefault={"Print x minuten van te voren"}
                      tKey={"vestigingen.form.preordering.label.preOrderPrintOffsetMin"}
                      type={"number"}
                    />
                  </>
                ) : null}{" "}
                {deliveryTimeSchemeModal ? (
                  <TimeoddsModal
                    open={deliveryTimeSchemeModal}
                    toggle={() => setDeliveryTimeSchemeModal(!deliveryTimeSchemeModal)}
                    type={deliveryTimeSchemeType}
                    vestiging_id={vestigingId}
                  />
                ) : null}
              </CardBody>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Preordering;
